import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { getSession } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }
    getSession(sessionId)
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [sessionId]);

  return (
    <section className="section" data-testid="payment-success-page">
      <div className="container-app max-w-2xl text-center">
        <CheckCircle2 className="w-16 h-16 text-teal mx-auto" />
        <h1 className="mt-6 text-5xl">Thank you for your trust.</h1>
        <p className="mt-4 text-navy/70 text-lg">
          Your payment has been received. A receipt is on its way to your email,
          and a member of our team will reach out shortly to begin onboarding.
        </p>
        {loading && <p className="mt-6 text-navy/60 inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Confirming…</p>}
        {data && (
          <div className="mt-8 card p-6 text-left text-sm text-navy/70">
            <div><strong>Status:</strong> {data.payment_status}</div>
            <div><strong>Amount:</strong> ${(data.amount_total / 100).toFixed(2)} {String(data.currency).toUpperCase()}</div>
          </div>
        )}
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link to="/intake" className="btn-primary">Complete Intake</Link>
          <Link to="/" className="btn-secondary">Back home</Link>
        </div>
      </div>
    </section>
  );
}

export function PaymentCancel() {
  return (
    <section className="section" data-testid="payment-cancel-page">
      <div className="container-app max-w-2xl text-center">
        <XCircle className="w-16 h-16 text-gold mx-auto" />
        <h1 className="mt-6 text-5xl">Checkout was cancelled.</h1>
        <p className="mt-4 text-navy/70 text-lg">
          No payment was processed. You can return to services any time, or reach
          out if you have questions.
        </p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link to="/services" className="btn-primary">Back to services</Link>
          <Link to="/contact" className="btn-secondary">Ask a question</Link>
        </div>
      </div>
    </section>
  );
}
